import { NgModule } from '@angular/core';
import { ToolbarModule } from '@components/toolbar';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '@directives/directives.module';
import { SingleSelectorModule } from '@shared/single-selector/single-selector.module';
import { ButtonModule } from '@components/button';
import { PopUpModule } from '@components/pop-up';
import { ProductListModule } from '@shared/product-list/product-list.module';
import { TranslateStringsModule } from '@components/translate-string';
import { CsIconModule } from '@components/icon';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { UserNotificationComponent } from './user-notification.component';
import { NotificationCardComponent } from './notification-card/notification-card.component';
import { NotificationDialogComponent } from './notification-popup/notification.dialog.component';
import { CAudioModule } from '../shared/c-audio/c-audio.module';
import { MultilineEllipsisComponent } from './multiline-ellipsis/multiline-ellipsis.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    RouterModule.forChild([
      { path: 'notification', component: UserNotificationComponent },
    ]),
    TranslateStringsModule,
    DirectivesModule,
    ProductListModule,
    ToolbarModule,
    SingleSelectorModule,
    ButtonModule,
    PopUpModule,
    CAudioModule,
    BrowserModule,
    CsIconModule,
  ],
  declarations: [UserNotificationComponent, MultilineEllipsisComponent, NotificationCardComponent, NotificationDialogComponent],
  exports: [UserNotificationComponent, NotificationCardComponent, NotificationDialogComponent],
})
export class UserNotificationModule { }
